import {
  DECORATIVE_ORDER_FAILED,
  DECORATIVE_ORDER_REQUEST,
  DECORATIVE_ORDER_SUCCESS,
} from "app/redux/actions/Order/DecorativeOrder/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const decorativeOrderReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case DECORATIVE_ORDER_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case DECORATIVE_ORDER_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case DECORATIVE_ORDER_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
